import cloneDeep from 'lodash.clonedeep';

export function transformIncomingAgentPermissions(permissions, apps) {
  const { general_permissions, app_permissions } = cloneDeep(permissions);

  const transformedAppPermissions = {};

  Object.entries(app_permissions).forEach(([prop, val]) => {
    if (prop === 'get_app_sales_file') return;

    transformedAppPermissions[prop] = val.for_all
      ? new Set(apps.map(({ packageName }) => packageName))
      : new Set(val.apps);
  });

  return {
    general_permissions: {
      general: {
        add_app: general_permissions.add_app,
        change_public_info: general_permissions.change_public_info,
        developers_api: general_permissions.developers_api,
        support: general_permissions.support,
      },
      finance: {
        view_finance_info: general_permissions.view_finance_info,
        change_finance_info: general_permissions.change_finance_info,
      },
    },
    app_permissions: transformedAppPermissions,
  };
}

export function transformOutgoingAgentPermissions({
  general_permissions,
  app_permissions,
}) {
  // Flatten general permissions
  let transformedGeneralPermissions = [];
  Object.values(general_permissions).forEach(subGeneralPermissions => {
    transformedGeneralPermissions = {
      ...transformedGeneralPermissions,
      ...subGeneralPermissions,
    };
  });

  const transformedAppPermissions = [];

  Object.entries(app_permissions).forEach(([prop, val]) => {
    transformedAppPermissions.push({
      slug: prop,
      for_all: false,
      apps: Array.from(val),
    });
  });

  return {
    general_permissions: transformedGeneralPermissions,
    app_permissions: transformedAppPermissions,
  };
}
